var interfaces;
(function (interfaces) {
    ;
})(interfaces || (interfaces = {}));
export { interfaces };
//# sourceMappingURL=interfaces.js.map